<div class="table-container">
    <table class="detail-table quote-request-span-tbl quote-request-span-tbl--recipients">
        <thead>
            <tr>
                <th>Email</th>
                <th>Sent</th>
                <th>Opened</th>
                <th>Status</th>
                <th>Submitted</th>
                <th>Amount</th>
                <th>Chosen</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let r of row().quoteRequestRecipients">
                <tr *ngIf="!!r">
                    <td>
                        <a class="btn-bx-hyperlink" [routerLink]="['/contacts', 'list', r.iD_Contact]">{{ r.email }}</a>
                    </td>
                    <td>{{ r.dateNotified | date }}</td>
                    <td>{{ r.dateOpened | date }}</td>
                    <td [innerHTML]="getResponseIcon(r)"></td>
                    <td>{{ r.dateSubmitted | date }}</td>
                    <td>{{ r.totalAmount | bxCurrency }}</td>
                    <td>
                        <div
                            *ngIf="r.quoteStatus === rfqStatus.Submitted"
                            class="margin-0 form-v2"
                            [title]="row().iD_PurchaseOrder || row().iD_Variation ? 'An order already exists' : ''">
                            <input
                                legacy-css
                                name="recipient"
                                type="checkbox"
                                class="form-control-v2"
                                [attr.id]="'recipient_' + r.iD_QuoteRequestRecipient"
                                (change)="onSelectedRecipientChanged(r, row())"
                                [(ngModel)]="r.isSelectedQuote"
                                [disabled]="
                                    !canSelectRfqResponse ||
                                    (row().estimateView?.isAccepted && !row().jobView) ||
                                    !!row().iD_PurchaseOrder ||
                                    !!row().iD_Variation
                                " />
                            <label [attr.for]="'recipient_' + r.iD_QuoteRequestRecipient"></label>
                        </div>
                    </td>
                    <td>
                        <div class="btn-container">
                            <button
                                id="view-submitted-quote-{{ rowIndex() }}"
                                class="btn-bx-secondary"
                                (click)="viewQuoteRequestRecipientResponse(r)">
                                View
                            </button>
                            <button
                                id="resend-qr-{{ rowIndex() }}"
                                [disabled]="row().status !== 'Open' || (row().status === 'Open' && r.quoteStatus === rfqStatus.Submitted)"
                                class="btn-bx-secondary-stroked"
                                (click)="resendQuoteRequest(row().iD_QuoteRequest, r.iD_QuoteRequestRecipient)">
                                Resend
                            </button>
                            <button
                                id="remind-qr-{{ rowIndex() }}"
                                [disabled]="row().status !== 'Open' || (row().status === 'Open' && r.quoteStatus === rfqStatus.Submitted)"
                                class="btn-bx-secondary-stroked"
                                (click)="remindQuoteRequest(row().iD_QuoteRequest, r.iD_QuoteRequestRecipient)">
                                Remind
                            </button>
                            <button
                                id="delete-recipient-{{ rowIndex() }}"
                                type="button"
                                class="btn btn-sm btn-danger"
                                *ngIf="row().status === 'Open'"
                                (click)="deleteRecipient($event, r)"
                                tooltip="Delete"
                                container="body">
                                <i class="ti-trash"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>

    <div class="panel panel-info panel-accept-quote" *ngIf="hasSelectedResponses(row()) && row().jobView">
        <div class="panel-body">
            <div class="quoterequest-btn-row" *ngIf="!row().iD_PurchaseOrder && !row().iD_Variation; else viewOrders">
                <button
                    id="create-variation-{{ rowIndex() }}"
                    type="button"
                    class="btn-bx-secondary"
                    (click)="addOrder(row(), rfqActions.Variation)">
                    Create Variation
                </button>
                <button
                    id="create-work-order-{{ rowIndex() }}"
                    type="button"
                    class="btn-bx-secondary"
                    (click)="addOrder(row(), rfqActions.Work)">
                    Create Work Order
                </button>
                <button
                    id="create-purchase-ord-{{ rowIndex() }}"
                    type="button"
                    class="btn-bx-secondary"
                    (click)="addOrder(row(), rfqActions.Purchase)">
                    Create Purchase Order
                </button>
            </div>
            <ng-template #viewOrders>
                <div class="quoterequest-btn-row">
                    <button id="view-order-{{ rowIndex() }}" type="button" class="btn-bx-secondary" (click)="viewOrderOrVariation(row())">
                        View Order
                    </button>
                </div>
            </ng-template>
        </div>
    </div>

    <div
        class="panel panel-info panel-accept-quote"
        *ngIf="hasSelectedResponses(row()) && row().estimateView?.isAccepted && row().status !== 'Accepted' && !row().jobView">
        <div class="panel-body row">
            <div class="col-md-1 col-xs-12">
                <i class="fa fa-exclamation-triangle fa-2x"></i>
            </div>
            <div class="col-md-7 col-xs-12">
                <p style="padding-left: 5px; color: #999">Accepting the preferred quote will notify the supplier/tradesperson.</p>
            </div>
            <div class="col-md-4 col-xs-12">
                <button
                    id="accept-pref-quote-{{ rowIndex() }}"
                    type="button"
                    class="btn-bx-primary pull-right"
                    (click)="acceptQuoteRequest(row())">
                    Accept Preferred Quote
                </button>
            </div>
        </div>
    </div>

    <div class="panel panel-info panel-accept-quote" *ngIf="canReopenRfq && row().status === 'Closed'">
        <div class="panel-body row">
            <div class="col-md-1 col-xs-12">
                <i class="fa fa-exclamation-triangle fa-2x"></i>
            </div>
            <div class="col-md-7 col-xs-12">
                <p style="padding-left: 5px; color: #999">
                    You can extend the deadline for this quote request if you need more time. The deadline will be changed to 1 week from
                    today and the quote request will be re-opened.
                </p>
            </div>
            <div class="col-md-4 col-xs-12">
                <button
                    id="extend-deadline-{{ rowIndex() }}"
                    type="button"
                    class="btn-bx-primary pull-right"
                    (click)="unacceptQuoteRequest(row())">
                    Extend deadline
                </button>
            </div>
        </div>
    </div>
</div>
